import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { Box } from '@mui/material';
import Badge from '@mui/material/Badge';
import Card from '@mui/material/Card';
import Popover from '@mui/material/Popover';
import * as React from 'react';
import UserSummary from '../../features/userprofile/UserSummary';
import { styles } from '../../style/style';
import LogoutButton from './LogoutButton';


export default function UserIcon() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (


        <div>
            <Badge>
                <AccountCircleOutlinedIcon id="profileIcon" onClick={handleClick} />
            </Badge>
            <Popover
            disableScrollLock={true}
            sx={styles.userPopover}
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Card sx={styles.userIconCard}>
                    <Box>
                        <UserSummary />
                    </Box>
                    <Box sx={styles.logout}>
                        <LogoutButton />
                    </Box >
                </Card>
            </Popover>
        </div>
    )
}